<template>
  <div>
    <a-modal title="修改表单数据" :visible.sync="visible" @cancel="clear" @ok="submit" width="700px">
      <a-form-model ref="form" :model="fieldVals">
        <div v-for="item in fieldConfig" :key="item.key" style="margin-bottom: 15px">
          <div v-if="item.fieldType != 8">
            <div style="font-size: 15px">
              <a-icon type="caret-right" class="text-primary v-mr-xs" />
              <span class="text-bold">{{ item.fieldName }}</span>
            </div>

            <div v-if="item.fieldType != 9">
              <a-form-model-item :colon="false" :prop="item.key" :rules="getRule(item)">
                <div class="field-input">
                  <!--单行文本-->
                  <a-input v-if="item.fieldType == 1" v-model="fieldVals[item.key]" />
                  <!--多行文本-->
                  <a-input v-if="item.fieldType == 4" v-model="fieldVals[item.key]" type="textarea" :auto-size="{ minRows: 4, maxRows: 20 }" />
                  <!--数字-->
                  <a-input-number v-if="item.fieldType == 7" v-model="fieldVals[item.key]" style="min-width: 200px" />

                  <!--单选框-->
                  <a-radio-group v-if="item.fieldType == 2" v-model="fieldVals[item.key]">
                    <span v-for="(val, index) in item.selectVals" :key="val">
                      <a-radio :value="val">{{ val }}</a-radio>
                      <a-input v-model="fieldVals[item.key + '_otherVal']" v-if="val === '其他' && item.withOther && index == item.selectVals.length - 1" size="small" style="width: 150px" />
                    </span>
                  </a-radio-group>

                  <!--多选框-->
                  <a-checkbox-group v-if="item.fieldType == 5" v-model="fieldVals[item.key]">
                    <a-checkbox v-for="val in item.selectVals" :value="val" :key="val">{{ val }}</a-checkbox>
                  </a-checkbox-group>
                  <!--日期-->
                  <a-date-picker v-if="item.fieldType == 6" v-model="fieldVals[item.key]" :inputReadOnly="true" />
                  <!--附件-->
                  <div v-if="item.fieldType == 3">
                    <a-upload name="file" :multiple="true" :action="`${baseURL}/activity/file/upload`" @change="fileUploadChange" :defaultFileList="getDefaultFileList(fieldVals[item.key + '_detail'], item.key)" :data="{ params: getParam({ fieldKey: item.key }) }">
                      <a-button type="primary" :disabled="item.max && (fieldVals[item.key] ? fieldVals[item.key].length : 0) >= item.max">
                        <a-icon type="upload" />
                        点击上传
                      </a-button>
                    </a-upload>
                    <span style="font-size: 10px; font-style: oblique">
                      <span v-if="item.required && item.min" style="margin-right: 10px">最少上传文件：{{ item.min }}</span>
                      <span v-if="item.max">最多上传文件：{{ item.max }}</span>
                    </span>
                  </div>
                </div>
              </a-form-model-item>
            </div>
            <div v-if="item.fieldType == 9">
              <a-form-model-item prop="area" :rules="getRule(item, 'area')">
                <div class="field-input">
                  <a-cascader expand-trigger="hover" :options="districts" placeholder="选择地区" v-model="fieldVals[item.key].area" style="width: 400px" />
                </div>
              </a-form-model-item>
              <a-form-model-item prop="address" :rules="getRule(item, 'address')">
                <div class="field-input">
                  <a-input placeholder="详细地址" v-model="fieldVals[item.key].address" />
                </div>
              </a-form-model-item>
            </div>
          </div>
        </div>
      </a-form-model>
    </a-modal>
  </div>
</template>
<script>
import { activityInstanceDetail, updateActivityInstance } from '@/api/activity'
import alldistricts from '@/utils/districts'
export default {
  name: 'formdata-edit',
  data() {
    return {
      visible: false,
      id: null,
      fieldConfig: null,
      fieldVals: null,
      districts: alldistricts,
    }
  },
  methods: {
    open(id) {
      this.id = id
      activityInstanceDetail({ id: this.id }).then(({ data }) => {
        if (data.success) {
          for (let config of data.result.fieldConfig) {
            if (9 == config.fieldType) {
              // console.log('config.key', config.key)
              // this.$set(this.fieldVals, config.key, {})
            }
            if ([2, 3].includes(config.fieldType)) {
              if (config.withOther) {
                config.selectVals.push('其他')
              }
            }
          }
          this.fieldConfig = data.result.fieldConfig

          let fieldVals = data.result.fieldVals
          for (let fieldKey in fieldVals) {
            if (fieldKey.endsWith('#2')) {
              let fieldVal = fieldVals[fieldKey]
              let index = fieldVal.indexOf('其他:')
              if (index != -1) {
                let otherVal = fieldVal.slice(index + 3)
                fieldVals[fieldKey] = '其他'
                fieldVals[fieldKey + '_otherVal'] = otherVal
              }
            }
          }
          this.fieldVals = data.result.fieldVals

          this.visible = true
        }
      })
    },
    clear() {
      this.visible = false
      this.id = null
      this.fieldConfig = null
      this.fieldVals = null
    },
    getRule(item, subtype) {
      let i = { ...item }
      let rules = []
      if (subtype) {
        i.subtype = subtype
      }
      rules.push({ required: true, item: i, trigger: 'blur', validator: this.myValidator })
      return rules
    },
    myValidator(rule, value, callback) {
      let item = rule.item
      if (item.fieldType == 9) {
        let subtype = item.subtype
        if (subtype) {
          if (item.required) {
            let finalVal = this.fieldVals[item.key][subtype]
            if ('area' == subtype) {
              if (!finalVal || finalVal.length == 0) {
                callback(new Error('地区不能为空'))
              } else {
                callback()
              }
              return
            }
            if ('address' == subtype) {
              if (!finalVal) {
                callback(new Error('详细地址不能为空'))
              } else {
                callback()
              }
              return
            }
          }
        }
      }
      if (item.required && item.fieldType == 3) {
        // 文件控件不允许为空的时候，检查最小上传的文件数
        let val = this.fieldVals[item.key]
        if (item.min && (!val || val.length < item.min)) {
          callback(new Error('最少上传' + item.min + '个文件'))
          return
        }
      }
      if (item.required && !value) {
        callback(new Error('不能为空！'))
        return
      }
      callback()
    },
    getParam({ fieldKey }) {
      let fileMark = this.$utils.uuid()
      return JSON.stringify({ fieldKey, fileMark, fileType: 2, fileSign: 'activity' })
    },
    getDefaultFileList(files, fieldKey) {
      if (!files) {
        return []
      }
      let defaultFileList = files.map(file => ({
        uid: this.$utils.uuid(),
        name: file.fileName,
        status: 'done',
        fieldKey: fieldKey,
        response: { result: { fileSign: 'activity', ...file } },
      }))
      return defaultFileList
    },
    fileUploadChange({ file }) {
      if (file.status === 'done') {
        let fieldKey = file.response.result.fieldKey
        let fileId = file.response.result.fileId
        let fileIds = this.fieldVals[fieldKey]
        if (!fileIds) {
          fileIds = [fileId]
        } else {
          fileIds.push(fileId)
        }
        this.$set(this.fieldVals, fieldKey, fileIds)
      } else if (file.status === 'removed') {
        console.log('file.response.result', file)
        let fieldKey = file.fieldKey

        let fileId = file.response.result.fileId
        let fileIds = this.fieldVals[fieldKey]

        let newFileIds = fileIds.filter(item => item != fileId)
        this.$set(this.fieldVals, fieldKey, newFileIds)
        // removeFile({ fileId })
      }
    },
    submit() {
      this.$refs.form.validate(valid => {
        if (valid) {
          this.submitLoading = true
          let params = {}
          params.id = this.id

          let fieldVals = {}
          for (let key in this.fieldVals) {
            if (!key.endsWith('_detail')) {
              fieldVals[key] = this.fieldVals[key]
            }
          }

          // 处理选择项中的“其他”
          for (let key in fieldVals) {
            if (key.endsWith('_otherVal')) {
              let selectKey = key.replace('_otherVal', '')
              if (fieldVals[selectKey] == '其他') {
                fieldVals[selectKey] = '其他:' + fieldVals[key]
              }
              delete fieldVals[key]
            }
            // if (key.endsWith('#3')) {
            //   let fileIds = fieldVals[key]
            //   console.log('fileIds#3', fileIds)
            //   // let fileIds = []
            //   // for (let fileItem of fileItems) {
            //   //   if (typeof fileItem == 'object') {
            //   //     fileIds.push(fileItem.fileId)
            //   //   } else if (typeof fileItem == 'number') {
            //   //     fileIds.push(fileItem)
            //   //   }
            //   // }
            //   // fieldVals[key] = fileIds
            // }
          }

          params.fieldValsStr = JSON.stringify(fieldVals)

          updateActivityInstance(params).then(({ data }) => {
            if (data.success) {
              this.visible = false
              this.$message.success('提交成功')
              this.$parent.load()
            } else {
              this.$message.warn(data.msg)
            }
          })
        } else {
          this.scrollToFirstError()
        }
      })
    },
    scrollToFirstError() {
      setTimeout(function () {
        let isError = document.getElementsByClassName('has-error')
        isError[0].scrollIntoView({
          block: 'center',
          behavior: 'smooth',
        })
      }, 200)
    },
  },
  created() {},
}
</script>
<style lang="scss"></style>
